type PasswordCheck = {
  description: string;
  regex: RegExp;
};

const PASSWORD_LOWER_CASE_LETTER_REGEX = /[a-z]/;
const PASSWORD_UPPER_CASE_LETTER_REGEX = /[A-Z]/;
const PASSWORD_NUMBER_REGEX = /\d/;
const PASSWORD_SYMBOL_REGEX = /[^A-Za-z0-9]/;
const PASSWORD_LENGTH_REGEX = /.{12,}/;

export const PASSWORD_CHECKS: PasswordCheck[] = [
  {
    description: 'At least one lowercase letter.',
    regex: PASSWORD_LOWER_CASE_LETTER_REGEX,
  },
  {
    description: 'At least one uppercase letter.',
    regex: PASSWORD_UPPER_CASE_LETTER_REGEX,
  },
  {
    description: 'At least one number.',
    regex: PASSWORD_NUMBER_REGEX,
  },
  {
    description: 'At least one symbol (e.g. !@#$...).',
    regex: PASSWORD_SYMBOL_REGEX,
  },
  {
    description: 'At least 12 characters.',
    regex: PASSWORD_LENGTH_REGEX,
  },
];

export const valid = (password: string): boolean => {
  return PASSWORD_CHECKS.every((check) => check.regex.test(password));
};

export const getFailedChecks = (password: string): string[] => {
  return PASSWORD_CHECKS.filter((check) => !check.regex.test(password)).map((check) => check.description);
};
